<template>
  <div :class="$style.base">
    <div :class="$style.header">
      <IconChevron :class="{ [$style.collapsed]: !isExpanded }" />
      <div :class="$style.info">
        <div :class="$style.left">
          <div
            :class="$style.name"
            v-test="'service-variation-group-item-name'"
          >
            {{ data.name }}
          </div>
        </div>
        <div v-if="settings.show_service_prices" :class="$style.right">
          <div :class="[$style.price]" v-test="'service-group-item-price'">
            {{ $t('general.from', { value: currency(data.price) }) }}
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.description" v-test="'service-group-item-description'">
      {{ data.description }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import IconChevron from '@/components/IconChevron.vue';
import { currency } from '@/helpers';
import { useCompanyStore } from '@/stores/company';

defineProps<{
  data: {
    name: string;
    price: number;
    description: string;
  };
  isExpanded: boolean;
}>();

const { settings } = useCompanyStore();
</script>

<style lang="scss" module>
.base {
  padding: ($spacing * 2) $spacing;
  border-bottom: 1px solid $color-border;
  cursor: pointer;
  width: 100%;

  &:last-of-type {
    border: none;
  }
}

.header {
  display: flex;
  align-items: flex-start;
}

.collapsed {
  transform: rotate(270deg);
}

.info {
  flex: 1;
  width: 100%;
  padding-left: $spacing;
  align-self: center;
  display: flex;
  justify-content: space-between;
}

.name {
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;

  &::first-letter {
    text-transform: uppercase;
  }
}

.price {
  font-size: 16px;
  line-height: 22px;
}

.description {
  padding: 8px 32px 0;
  font-size: 13px;
  line-height: 20px;
  opacity: 0.7;
}
</style>
